// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__k7cd4","list--scrollbox":"List_list--scrollbox__35qjj","listItem":"List_listItem__2GFzW"};